"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.curry = void 0;
/**
 * A function that takes multiple arguments and returns a curried method.
 *
 * @category Function
 * @param {Function} fn - the function to curry
 * @returns {Function} the curried method with arguments
 *
 * @example
 * const sum = (a, b, c) => a + b + c
 * const curriedSum = curry(sum)
 * curriedSum(1)(2, 3) //=> 6
 */
var curry = function (fn) {
    return function curried() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (args.length >= fn.length) {
            return fn.apply(this, args);
        }
        return function () {
            var _args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                _args[_i] = arguments[_i];
            }
            return curried.apply(this, args.concat(_args));
        };
    };
};
exports.curry = curry;
